import React, { useState } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import css from './TransactionTabs.css';

export default function TransactionTabs(props) {
  const { tabs, txType, currentUser, displayReceiver } = props;

  const [activeTab, setActiveTab] = useState(txType || 'overdue');

  const transactionsToShow = tabs.find(t => t.id === activeTab)?.data || [];

  return (
    <>
      <div className={css.tabs}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={classNames(css.tab, { [css.activeTab]: activeTab === tab.id })}
            onClick={() => setActiveTab(tab.id)}
          >
            <FormattedMessage id={`TransactionsModal.tab.${tab.id}`} defaultMessage={tab} />
            {tab.data?.length > 0 && <span> ({tab.data?.length})</span>}
          </button>
        ))}
      </div>
      <div className={css.transactionList}>
        {transactionsToShow.map(tx => {
          const isStolen = activeTab === 'overdue' && tx.attributes.stolen;
          return (
            <div key={tx.id.uuid} className={css.transaction}>
              <div className={css.transactionHeader}>
                <div>
                  {currentUser?.attributes.isAdmin ||
                  currentUser?.attributes.adminForCountries?.length > 0 ? (
                    <NamedLink
                      name={tx.attributes.serviceFee ? 'SaleServiceFeeDetailsPage' : 'SalePage'}
                      params={{ id: tx.id.uuid }}
                      className={css.code}
                    >
                      {tx.attributes.code}
                    </NamedLink>
                  ) : (
                    <span className={css.code}>{tx.attributes.code}</span>
                  )}
                  {!tx.attributes.serviceFee ? (
                    <span className={classNames(css.txState, { [css.stolen]: isStolen })}>
                      <FormattedMessage
                        id={
                          !isStolen
                            ? `TransactionsModal.state.${tx.attributes.processState}`
                            : 'TransactionsModal.transactionStolen'
                        }
                      />
                    </span>
                  ) : (
                    <span className={css.txState}>nieopłacona</span>
                  )}
                </div>
                {!tx.attributes.serviceFee ? (
                  <span>
                    {tx.attributes.start} -{' '}
                    {moment(tx.attributes.end)
                      .add(-1, 'days')
                      .format('YYYY-MM-DD')}
                  </span>
                ) : (
                  <span>{moment(tx.attributes.createdAt).format('YYYY-MM-DD')}</span>
                )}
              </div>
              {!tx.attributes.serviceFee ? (
                <div className={css.listings}>
                  {tx.listings.map(l => (
                    <div key={l.id.uuid}>{`${l.meta.seats} x ${l.attributes.title}`}</div>
                  ))}
                </div>
              ) : (
                <div className={css.listings}>
                  <div>{tx.attributes.serviceFee.reason}</div>
                </div>
              )}
              {displayReceiver && !tx.attributes.serviceFee && (
                <div>Odbierający: {tx.attributes.receiverName}</div>
              )}
              <div>{tx.provider.attributes.name}</div>
            </div>
          );
        })}
      </div>
    </>
  );
}
